var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4WcMan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v16.49a2 2 0 01-2.65 1.89 2 2 0 01-1.35-2V24a1 1 0 00-1-1h-2v44.32a2 2 0 01-2.65 1.9 2 2 0 01-1.35-2V48h-3v19.32a2 2 0 01-2.65 1.9 2 2 0 01-1.35-2V23h-2a1 1 0 00-1 1v16.4a2 2 0 01-2.293 2.087A2 2 0 0125 40.49V24a5 5 0 015-5h15a5 5 0 015 5zm-9.3-8.1a5 5 0 10-6.193-7.85A5 5 0 0040.7 15.9z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_WC_man.33a0bac7.svg";
export { SvgE4WcMan as ReactComponent };